import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiRadio } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-black py-20 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-12 mb-20">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-[#DFFF00] flex items-center justify-center rounded-sm">
                <SafeIcon icon={FiRadio} className="text-black" />
              </div>
              <span className="text-xl font-black tracking-tighter uppercase text-white">DUBTRACKFM.</span>
            </div>
            <p className="text-slate-600 text-xs font-black uppercase tracking-[0.3em]">Industrial Content Infrastructure</p>
          </div>
          
          <div className="flex flex-wrap gap-12">
            <div>
              <h4 className="text-white text-[10px] font-black uppercase tracking-[0.4em] mb-6">Legal</h4>
              <div className="flex flex-col gap-4 text-slate-500 font-bold uppercase text-[10px] tracking-widest">
                <Link to="/terms" className="hover:text-[#DFFF00] transition-colors">Terms of Service</Link>
                <Link to="/refunds" className="hover:text-[#DFFF00] transition-colors">Refund Policy</Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center pt-12 border-t border-white/5 gap-6">
          <p className="text-[10px] text-slate-700 font-black uppercase tracking-[0.5em]">
            © {new Date().getFullYear()} DUBTRACKFM DEPLOYMENT // ALL RIGHTS RESERVED
          </p>
          <div className="text-[10px] text-slate-700 font-black uppercase tracking-widest">
            OPERATIONAL_STATUS: <span className="text-[#DFFF00]">OPTIMAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
}